// "Is a newer build deployed than the one this tab is running?"
//
// vite.config.js emits dist/version.json ({ version, sha }) on every build,
// and bakes the same sha into the bundle as __BUILD_SHA__. UpdatePrompt.jsx
// polls the file and asks these two functions whether to offer a refresh.
// Pure and free of React/DOM so tests/build-version.test.js can run it in
// Vitest's `node` environment.
//
// The sha is the comparison key, not the version: it changes on every
// deploy, whereas the version only changes when someone remembers to bump it.

export function readBuildSha(payload) {
  const sha = payload && typeof payload === 'object' ? payload.sha : null
  return typeof sha === 'string' && sha ? sha : null
}

// 'dev' is vite.config.js's fallback when neither CF_PAGES_COMMIT_SHA nor git
// is available. Such a build has nothing meaningful to compare, so it never
// prompts.
export function isNewBuild(currentSha, deployedSha) {
  if (!currentSha || currentSha === 'dev' || !deployedSha) return false
  return currentSha !== deployedSha
}
